package com.yogaaicoach.pages.workout.data

import com.yogaaicoach.common.network.ApiClient
import com.yogaaicoach.pages.workout.data.models.ExerciseResponse
import io.ktor.http.*
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class ExerciseApi(private val client: ApiClient) {
    @OptIn(ExperimentalUuidApi::class)
    suspend fun getExercise(exerciseGuid: Uuid, duration: Int, preferOtherSide: Boolean = false): ExerciseResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/exercise?exerciseGuid=$exerciseGuid&duration=$duration&preferOtherSide=$preferOtherSide",
            method = HttpMethod.Get,
        )
    }
}